const initialState = {
  pdfDownload: false,
  pdfViewCounter: 0,
  shortlistViewCounter: 0,
  tourCounter: 0,
  dealId: '',
  displayDate: '',
  displayURLPath: '',
  displayMails: [],
  displayCCMails: '',
  hoveredElement: {},
  successElement: false,
  displayShortlistedProvider: '',
  displayShortlistedProviderContact: '',
  latLong: [],
  commonQuery: '',
  tourReqDate: '',
  currentDeal: {},
  editClientDeliverableCounter: 0,
};

const commonReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_DATE':
      return {
        ...state,
        displayDate: action.date,
      };

    case 'SET_FLEXPERTS_EMAIL':
      return {
        ...state,
        displayMails: action.emails,
      };
    case 'SET_CC_EMAIL':
      return {
        ...state,
        displayCCMails: action.ccmails,
      };
    case 'SET_SHORTLISTED_PROVIDER':
      return {
        ...state,
        displayShortlistedProvider: action.shortlistedProvider,
      };
    case 'SET_SHORTLISTED_PROVIDER_CONTACT':
      return {
        ...state,
        displayShortlistedProviderContact: action.shortlistedProvidercontact,
      };
    case 'SET_CURRENT_LOCATION':
      return {
        ...state,
        displayCurrentLocation: action.currentLocation,
      };

    case 'SET_HOVERED_ELEMENT':
      return {
        ...state,
        hoveredElement: action.hoveredElement,
      };

    case 'SET_SUCCESS_ELEMENT':
      return {
        ...state,
        successElement: action.successElement,
      };

    case 'SET_LAT_LONG_CURRENT_LOCATION':
      return {
        ...state,
        latLong: action.latLng,
      };
    case 'SET_URL_PATH':
      return {
        ...state,
        displayURLPath: action.urlPath,
      };
    case 'SET_COMMON_QUERY':
      return {
        ...state,
        displayCommonQuery: action.commonQuery,
      };
    case 'SET_PDF_DOWNLOAD':
      return {
        ...state,
        pdfDownload: action.pdfDownload,
      };
    case 'SET_PDF_VIEW_COUNTER':
      return {
        ...state,
        pdfViewCounter: action.pdfViewCounter,
      };
    case 'SET_SHORTLIST_VIEW_COUNTER':
      return {
        ...state,
        shortlistViewCounter: action.shortlistViewCounter,
      };
    case 'SET_REQUEST_TOUR_VIEW_COUNTER':
      return {
        ...state,
        tourCounter: action.tourCounter,
      };
    case 'SET_DEAL_ID':
      return {
        ...state,
        dealId: action.dealId,
      };
    case 'SET_CURRENT_DEAL':
      return {
        ...state,
        currentDeal: action.currentDeal,
      };

    case 'SET_TOUR_REQ_DATE':
      return {
        ...state,
        tourReqDate: action.tourReqDate,
      };
    case 'SET_LOCAL_BROKER_COUNTER':
      return {
        ...state,
        editClientDeliverableCounter: action.editClientDeliverableCounter,
      };
    default:
      return state;
  }
};

export default commonReducer;
